import { MotiText } from 'moti'
import { cssInterop } from 'nativewind'
import React from 'react'
import { View } from 'react-native'
import { tv } from 'tailwind-variants'

cssInterop(MotiText, {
  className: {
    target: 'style',
  },
})

const animatedPriceStyles = tv({
  slots: {
    wrapper: 'flex-row items-baseline',
  },
})

const CHAR_STAGGER_MS = 20

const charSpring = { type: 'spring' as const, stiffness: 600, damping: 30, mass: 1 }

const charTransition = (index: number) => ({
  opacity: { ...charSpring, delay: index * CHAR_STAGGER_MS },
  scale: { ...charSpring, delay: index * CHAR_STAGGER_MS },
})

type Props = {
  price: string
  className?: string
  testID?: string
}

export const AnimatedPrice = (props: Props) => {
  const { wrapper } = animatedPriceStyles()

  return (
    <View key={props.price} className={wrapper()} testID={props.testID}>
      {[...props.price].map((character, index) => (
        <MotiText
          key={index}
          className={props.className}
          from={{ opacity: 0, scale: 0.4 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={charTransition(index)}
        >
          {character === ' ' ? '\u00A0' : character}
        </MotiText>
      ))}
    </View>
  )
}
